const API_URL = process.env.REACT_APP_RTBAuthServiceURL;


const Apis = {
    
    //Login Otp Api
    GetLoginOtp: (mobile) => `${API_URL}/user/get/otp?mobile=${mobile}`,
    ResendLoginOtp: (transactionId) => `${API_URL}/user/get/resend_login_otp?transactionId=${transactionId}`,
    
    //login Api
    Login: `${API_URL}/user/login`,

    //Logout Api
    UserLogout: `${API_URL}/user/logout`,

    //Location Api
    GetStatesData: (countryName) => `${API_URL}/region/states/${countryName}`,
    GetCitiesData: (stateName) => `${API_URL}/region/cities/${stateName}`,

    //Upload Attachment
    UploadAttachment: `${API_URL}/file/uploadAttachment`,

    //Become a member API
    SavePersonalInfoData: `${API_URL}/membership/first-form/save-update`,
    FetchPersonalInfoData: (userId) => `${API_URL}/membership/get-first-form-info?userId=${userId}`,
    SaveProfessionalInfoData: `${API_URL}/membership/second-form/save-update`,
    FetchProfessionalInfoData: (userId) => `${API_URL}/membership/get-second-form-info?userId=${userId}`,
    FetchUserDetailsData: (userId) => `${API_URL}/membership/get?userId=${userId}`,

    //Membership Plans
    FetchMembershipOptions: (tenure) =>  `${API_URL}/membership/tier/benefit/enable-list?tenure=${tenure}`,

    //Checkout API
    CreatePayment: `${API_URL}/payment/create_order`,
    PaymentUpdate: `${API_URL}/payment/update_payment`,

    //Member Details
    FetchMemberDetails: (userId) => `${API_URL}/user/get/info?userId=${userId}`,

    //RequestCallback
    SubmitRequestCallbackForm: `${API_URL}/booking-request/save`,

    //Contact Us
    SaveContactUsRequest: `${API_URL}/contactus/create`,

    // Booking Api
    FetchMemberBookingDetails: (data) => `${API_URL}/booking/get-by-userId?userId=${data?.userId}&page=${data?.page}&size=${data?.size}`,
    FetchMemberTransactionDetails: (data) => `${API_URL}/loyalty/transaction/get?userId=${data?.userId}&page=${data?.page}&size=${data?.size}`,

    CheckProfileStatus: (userId) => `${API_URL}/user/is_profile_completed?userId=${userId}`,
    UpdateUserProfilePicture: `${API_URL}/user/update-profile`,

    //Coupon Api
    GetUserCouponList: (userId) => `${API_URL}/coupon/user/list?userId=${userId}`,
};
export { API_URL, Apis };